"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CarListingOfferListItemMobileView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/views/CarListingOfferListItemMobileView"));
const CarListingOfferListItemDesktopView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/views/CarListingOfferListItemDesktopView"));
const LocalStorageHandler_1 = __importDefault(require("@react/web/Common/LocalStorage/LocalStorageHandler"));
const LocalStorageKeyEnum_1 = __importDefault(require("@react/web/Common/LocalStorage/LocalStorageKeyEnum"));
const PageHelper_1 = __importDefault(require("@react/web/Listing/PageHelper/PageHelper"));
const CarListingOfferListItemView = ({ isWebpSupported, listingOffer, simpleOffer, filterCount, isSmallScreen, }) => {
    const contractLengths = simpleOffer.priceOfferList.getContractLengthString();
    const mileage = simpleOffer.priceOfferList.getMileageString();
    const topEquipmentLabels = (filterCount === 0 && listingOffer.simpleOfferList.getCount() === 1)
        ? listingOffer.topEquipmentLabels : simpleOffer.topEquipmentLabels;
    const imageThumb = isWebpSupported && simpleOffer.image.hasWebpImage && simpleOffer.image.thumbWebp
        ? simpleOffer.image.thumbWebp
        : simpleOffer.image.thumb;
    const imageMedium = isWebpSupported && simpleOffer.image.hasWebpImage && simpleOffer.image.mediumWebp
        ? simpleOffer.image.mediumWebp
        : simpleOffer.image.medium;
    const gtmClass = 'gtm-dk-car-offer-card-link';
    const cheapestPriceOffer = simpleOffer.priceOfferList.getCheapestPriceOffer();
    const detailUrl = cheapestPriceOffer.priceOfferDetailUrl;
    const handleClick = (event, carDetailUrl) => {
        LocalStorageHandler_1.default.setDataToLocalStorage(LocalStorageKeyEnum_1.default.LOCAL_STORAGE_SCROLL_TOP_KEY, String(window.scrollY));
        if (PageHelper_1.default.shouldOpenInNewTab(event) === true) {
            return;
        }
        event.preventDefault();
        window.location.href = carDetailUrl;
    };
    return react_1.default.createElement(react_1.default.Fragment, null,
        isSmallScreen === true
            && react_1.default.createElement(CarListingOfferListItemMobileView_1.default, { listingOffer: listingOffer, detailUrl: detailUrl, gtmClass: gtmClass, simpleOffer: simpleOffer, contractLengths: contractLengths, mileage: mileage, imageThumb: imageThumb, imageMedium: imageMedium, topEquipmentLabels: topEquipmentLabels, cheapestPriceOffer: cheapestPriceOffer, handleClick: handleClick }),
        isSmallScreen === false
            && react_1.default.createElement(CarListingOfferListItemDesktopView_1.default, { listingOffer: listingOffer, detailUrl: detailUrl, gtmClass: gtmClass, simpleOffer: simpleOffer, contractLengths: contractLengths, mileage: mileage, imageThumb: imageThumb, imageMedium: imageMedium, topEquipmentLabels: topEquipmentLabels, cheapestPriceOffer: cheapestPriceOffer, handleClick: handleClick }));
};
exports.default = CarListingOfferListItemView;
